import { toNumberLikeString } from "../../../../../features/dataFormatFunctions/dataFormatter"
import { store } from "../../../../../stateManagement/store"

function getColorOfRoadMeasureResult(value: number, admissibleValue: number, lessIsBetter: boolean) {
    if (!admissibleValue || !lessIsBetter) return
    if (value == admissibleValue) return 'orange'
    const isInadmissible = lessIsBetter ? value > admissibleValue : value < admissibleValue
    return isInadmissible ? 'red' : undefined
}

export function roadMeasureResultsBodyTemplate(rowData: any, field: any) {
    const currentRoadMeasure = store.getState().roadMeasures.currentRoadMeasure
    let { AdmissibleValue, LessIsBetter } = currentRoadMeasure ?? {}
    const rawValue = rowData[field]
    const value = parseFloat(toNumberLikeString(rawValue))
    const color = getColorOfRoadMeasureResult(value, AdmissibleValue, LessIsBetter)
    return (
        <div>
            {rawValue != null
                ?
                <div>
                    <span style={{ color }}>{rawValue}</span>
                </div>
                :
                <div>—</div>
            }
        </div >
    );
}